import { TipoCompensacaoManual, zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

const destinoSchema = z.object({
    data: z.coerce.date(),
})

export const createCompensacaoManualSchema = z.object({
    tipo: z.nativeEnum(TipoCompensacaoManual, {
        required_error: 'Selecione o tipo de compensação',
    }),
    empresaId: z.number().optional().nullable(),
    funcionarioId: z.number().optional().nullable(),
    calculoId: z.number().optional().nullable(),
    competencia: z.string().regex(/^\d{4}-\d{2}$/, {
        message: 'Competência deve estar no formato YYYY-MM',
    }),
    data: z.any(),
    destinos: z.array(destinoSchema).optional().default([]),
})

export const updateCompensacaoManualSchema = createCompensacaoManualSchema
    .partial()
    .omit({ empresaId: true, funcionarioId: true })

export type CreateCompensacaoManual = z.infer<
    typeof createCompensacaoManualSchema
>
export type UpdateCompensacaoManual = z.infer<
    typeof updateCompensacaoManualSchema
>

export type CompensacaoManualDestino = {
    id: number
    compensacaoManualId: number
    data: Date
    createdAt: Date
    updatedAt: Date
}

export type CompensacaoManual = z.infer<typeof zod.CompensacaoManualSchema> & {
    Destinos?: CompensacaoManualDestino[]
    Funcionario?: { nome: string }
}

const service = new ApiService<
    CreateCompensacaoManual,
    CompensacaoManual,
    {
        funcionarioIds?: number[]
        empresaId?: number
        competencia?: string
    }
>('compensacao-manual')

export const compensacaoManual = Object.assign(service, {})
